import Oidc from 'oidc-client';

export default {
    name: 'auth-callback',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {
        this.loginCallback()
    },
    methods: {
        loginCallback() {
            let self = this;

            new Oidc.UserManager({ response_mode: "query" }).signinRedirectCallback().then(function (user) {
                var showWelcomeScreenKey = 'showWelcome-' + user.profile.sub;
                var showWelcomeScreen = localStorage.getItem(showWelcomeScreenKey) || null;

                self.logLoginSuccessEvent(user);

                if ((showWelcomeScreen === null || showWelcomeScreen === 'true') && user.profile.show_welcome_screen === 'true') {
                    if (showWelcomeScreen === null) {
                        localStorage.setItem(showWelcomeScreenKey, user.profile.show_welcome_screen);
                    }
                    self.$state.set("welcome", true);
                    self.$router.replace('welcome?source=' + user.profile.idp);
                } else {
                    self.$api.getQuestionnaire(user).then(function (questionnaire) {
                        if (sessionStorage.lastKnownUrl) {
                            if (questionnaire && questionnaire.isSubmitted) {
                                self.$router.push(sessionStorage.lastKnownUrl);
                            } else if (sessionStorage.lastKnownUrl.indexOf('recommendations') != -1 || sessionStorage.lastKnownUrl.indexOf('report') != -1) {
                                self.$router.push('/');
                            } else {
                                self.$router.push(sessionStorage.lastKnownUrl);
                            }
                        } else {
                            if (questionnaire && questionnaire.isSubmitted) {
                                self.$router.push('report');
                            } else {
                                self.$router.push('/');
                            }
                        }
                    });
                }
            }).catch(function () {
                self.$router.push('/');
            });
        },
        logLoginSuccessEvent(user) {
            if (this.$gtm) {
                this.$gtm.trackEvent({
                    event: 'Sign In',
                    category: 'Authentication',
                    action: 'redirect',
                    label: 'Successful Login',
                    value: user.profile.idp
                });

                if (user.profile.just_signed_up) {
                    this.$gtm.trackEvent({
                        event: 'Sign Up',
                        category: 'Authentication',
                        action: 'redirect',
                        label: 'Successful Registration',
                        value: user.profile.idp
                    });
                }
            }
        }
    }
}
